// Module
var code = "<div layout=\"row\"> <span flex class=\"br-body-2\" layout-align=\"start center\">{{$ctrl.selectedBillingAccount.accountingName}}</span> </div> ";
// Exports
export default code;